/* istanbul ignore file */
import React from 'react';
import { Button } from 'framework/ui/mui-builder';
import RemoveIcon from '@mui/icons-material/RemoveOutlined';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

interface RemoveListItemButtonProps {
  isVisible?: boolean;
  onClickCallback: () => void;
  isFirstRow?: boolean;
  specificStyle?: React.CSSProperties | undefined;
  sx?: SxProps<Theme>;
}

const RemoveListItemButton = ({
  isVisible,
  onClickCallback,
  isFirstRow = false,
  specificStyle,
  sx,
}: RemoveListItemButtonProps) => {
  return isVisible ? (
    <Button
      style={specificStyle}
      size="small"
      onClick={onClickCallback}
      sx={[
        {
          p: 0.5,
          minWidth: '1px',
          width: { xs: '100%', md: 'auto' },
          mb: isFirstRow ? '25px !important' : { xs: 2, md: 0 },
          mt: isFirstRow ? '30px !important' : '6px !important',
          '& .MuiSvgIcon-root': {
            width: '0.75em',
            height: '0.75em',
          },
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      <RemoveIcon />
    </Button>
  ) : null;
};

export default RemoveListItemButton;
